// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const JeepTheme = props => {
	useThemeStylesheet(() => import("./jeep.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default JeepTheme;
